import { ImpactedCompany } from '@toggle/toggle';
import React from 'react';
import { useTranslation } from 'react-i18next';

import { useEntities } from '~/hooks/use-entities';

import { CompanyCard } from './company-card/CompanyCard';
import { CompanyCardRecap } from './company-card/CompanyCardRecap';
import * as S from './ImpactedCompanies.styles';

export interface ImpactedCompaniesProps {
  impactedCompanies: ImpactedCompany[];
  variant?: 'primary' | 'secondary';
  insightEarningId?: string;
}

export const ImpactedCompanies = ({
  impactedCompanies,
  variant = 'primary',
  insightEarningId,
}: ImpactedCompaniesProps) => {
  const { t } = useTranslation(['earnings']);

  const entityTags = impactedCompanies.map(c => c.entity_tag);
  const { data: entities } = useEntities({
    entityTags,
    enabled: !!entityTags.length,
  });

  return (
    <S.Root>
      <S.Title>
        {t('earnings:earningsInsight.drawer.impactedCompanies')}
      </S.Title>
      <S.CompaniesWrapper>
        {impactedCompanies.map((company, index) => {
          const entity = entities?.find(e => e.tag === company.entity_tag);

          if (!entity) {
            return <S.StyledLoader key={index} />;
          }

          if (variant === 'primary') {
            return (
              <CompanyCard
                key={company.entity_tag}
                company={company}
                entity={entity}
              />
            );
          }

          return (
            <CompanyCardRecap
              key={company.entity_tag}
              company={company}
              entity={entity}
              insightEarningId={insightEarningId}
            />
          );
        })}
      </S.CompaniesWrapper>
    </S.Root>
  );
};
